<template>
  <svg width="15  " height="15" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 1.57718L6.28571 15L0 8.84787L1.61143 7.27069L6.28571 11.8345L18.3886 1.7068e-07L20 1.57718Z" fill="#00527F"/>
  </svg>
</template>

<script>
  export default {
    name: 'acceptIcon'
  }
</script>

<style scoped>
  svg {
    max-width: 15px;
  }
</style>
